import React, { Component } from "react";
import PropTypes from "prop-types";
import {connect} from 'react-redux';
import {Loading} from "./loading"

class ViewContainer extends Component {

    render() {
        const title = this.props.title ? <h1>{this.props.title}</h1> : <div className="album-item-spacer"></div>;
        const description = this.props.description ? <h2>{this.props.description}</h2> : <div className="album-item-spacer"></div>;
        const loading = this.props.isLoading ? <Loading/>:"";
        return (
            <div className={"content-aware-container " + (this.props.className||"")} onScroll={this.props.onScroll || undefined}>
                {title}
                {description}
                {loading}
                {this.props.children}
            </div>

        )
    }
}
ViewContainer.propTypes = {
    viewClicked: PropTypes.func,
    title: PropTypes.string,
    className: PropTypes.string,
    description: PropTypes.string,
    onScroll: PropTypes.func,
    isLoading: PropTypes.bool
}
const mapStateToProps = state => {
    return {
        isLoading: state.applicationState.isLoading
    }
}
const mapDispatchToProps = dispatch => {
    return {}

}
export default connect(mapStateToProps, mapDispatchToProps)(ViewContainer);



// WEBPACK FOOTER //
// ./src/common/components/view-container.jsx